import {Row} from "react-bootstrap";
import React from "react";
import {CalendarMonth} from "../components/CalendarMonth.jsx";

export function CalendarPage(props) {
    const {tasks, small, onOpenChange, onTaskEditingChange} = props;
    return <Row className={"g-0"}>
        <CalendarMonth small={small} onOpenChange={onOpenChange} onTaskEditingChange={onTaskEditingChange}
                       tasks={tasks}/>
    </Row>
}
